import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconNotifications(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12 21.5c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2Zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 4.86 6 7.42 6 10.5v5l-2 2v1h16v-1l-2-2Zm-2 1H8v-6C8 8.02 9.51 6 12 6s4 2.02 4 4.5v6Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
